__turbopack_context__.v({
  "content": "DashboardPagesLayout-module__7QqE0a__content",
  "contentFlush": "DashboardPagesLayout-module__7QqE0a__contentFlush",
  "filters": "DashboardPagesLayout-module__7QqE0a__filters",
  "root": "DashboardPagesLayout-module__7QqE0a__root",
});
